/**
 * Appends `px` when the width is a unitless number.
 * Values that already include a unit are returned unchanged.
 *
 * @param width - A bare number ("400", "12.5") or a CSS length ("400px", "50%").
 * @returns The width with `px` appended when it had no unit.
 */
export function getPanelWidth(width: string) {
  return /^\d+(\.\d+)?$/.test(width) ? `${width}px` : width;
}
